module.exports = __webpack_public_path__ + "static/img/alcon.cf7f87d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alcon.png
// module id = fA94
// module chunks = 1